import React, { Component } from 'react';

import { Tag } from '@jd/find-react';

import KeeVue from '../base/KeeVue.js'
export default class FsTag extends KeeVue {
    constructor(props){
        super(props);
        this.state = { };
    };

    componentDidMount() {
        this.registComponent();
    }

    componentWillReceiveProps(nextProps){
        this.refresh();
    }

    setTitle=(title)=> {
        this.props.component.cp.tagTitle = title;
    }

    render() {
        let item = this.props.component;
        let tagTitleType = this.props.component.cp.tagTitleType;
        //标题是文本或者数据字典 文本直接取设置的值，数据字典查询一次
        let title = "标题";
        if (tagTitleType ==='text') {
            title = this.props.component.cp.tagTitle
        } else if (tagTitleType ==='dict') {
            title = this.getDictTitle(item.value,this.props.component.cp.tagTitle)
        }
        //color是固定类型或自定义，自定义是前端用户配置的json 根据key取对应value
        let color = this.props.component.cp.tagColor;
        if (color === 'customize') {
            let tagColorCustomizeJson = JSON.parse(this.props.component.cp.tagColorCustomize);
            color = tagColorCustomizeJson[item.value]
        }
        if(this.props.debug == true) {
            color = 'blue';
            title = 'Tag'
        }
        return (
            <div>
                <Tag
                    color={color}
                >{title}

                </Tag>
            </div>
        )
    }
}